import order from './order'

const authentication = {
    order: Object.assign(order, order),
}

export default authentication